import {Selectors} from '../Settings';

import Shortcuts from '../Elements/Shortcuts';

class ShortcutController {
    constructor() {
        this.initializeElements();
    }

    initializeElements() {
        this.initializeElement(Selectors.shortcuts, Shortcuts);
    }

    initializeElement(elementSelector, elementClass) {
        let $element = $(elementSelector);
        if ($element.length > 0) {
            new elementClass($element);
        }
    }
}

export default ShortcutController;